/**
 * 导出文件
 * @param {*} resBlob 二进制流
 * @param {*} fileName 包含后缀的文件名
 * @param type 文件类型
 * @param target
 */
export function downFile(resBlob, fileName, type, target = "") {
  const blob = new Blob([resBlob], {
    type: type,
  });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // 兼容IE
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.target = target;
    a.style.display = "none";
    a.setAttribute("download", fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  }
}

/**
 * 将file对象（.json文件）转为json对象
 * @param {File} file file对象
 */
export function fileToJson(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (res) => {
      const { result } = res.target; // 得到字符串
      const data = JSON.parse(result); // 解析成json对象
      resolve(data);
    }; // 成功回调
    reader.onerror = (err) => {
      reject(err);
    }; // 失败回调
    reader.readAsText(new Blob([file]), "utf-8"); // 按照utf-8编码解析
  });
}

export async function readBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (loadEvent) => resolve(loadEvent.target.result);
    reader.onerror = (e) => reject(e);
    reader.readAsArrayBuffer(file);
  });
}

// export function loadJs(src) {
//   return new Promise((resolve, reject) => {
//     let script = document.createElement('script');
//     script.type = 'text/javascript';
//     script.src = src;
//     document.body.appendChild(script);
//
//     script.onload = () => {
//       console.log(`加载资源：${src}成功`);
//       resolve();
//     }
//
//     script.onerror = () => {
//       console.log(`加载资源${src}失败`);
//       reject();
//     }
//   })
// }
